import { Button, Modal } from "antd";
import React from "react";
import { getParamUrlByKey } from "../utils";
import success from "../assets/success_img.png";

export default function SuccessModal({ open, dataOrder }) {
  const isApp = getParamUrlByKey("platform") === "app";

  const payOrder = () => {
    if (!dataOrder?.paymentLink) return;
    window.location.replace(dataOrder?.paymentLink);
  };

  return (
    <Modal open={open} closable={false} footer={null} centered>
      {isApp ? (
        <div className="success_modal">
          <img src={success} width={80} />
          <div className="title">Đã thêm vào giỏ hàng</div>
          <div className="content">
            Đơn hàng <b>Tomato</b> đã được thêm vào giỏ hàng <b>thành công.</b>
          </div>
          <div className="btn-wrapper">
            <Button
              className="btn back"
              onClick={() => window.location.reload()}
            >
              Tiếp tục mua hàng
            </Button>
            <Button
              className="btn next"
              onClick={() => window.ReactNativeWebView.postMessage("gotocart")}
            >
              Đi đến giỏ hàng
            </Button>
          </div>
        </div>
      ) : (
        <div className="success_modal">
          <img src={success} width={80} />
          <div className="title">Tạo đơn hàng thành công</div>
          <div>
            {dataOrder?.paymentDescription ? (
              dataOrder?.paymentDescription
            ) : (
              <div>
                Để thực hiện thanh toán cho đơn hàng này, hệ thống sẽ chuyển bạn
                tới cổng thanh toán VNPT. Global Care sẽ không lưu trữ thông tin
                của bạn dưới bất kỳ hình thức nào.
              </div>
            )}
          </div>

          <Button className="mt-15 btn next w-90" onClick={() => payOrder()}>
            Thanh toán ngay
          </Button>
        </div>
      )}
    </Modal>
  );
}
